import * as GLOBAL from "../data/global.js";

export default class RoleServices {

    static getRoles() {
        return fetch(`${global.SERVER_ADDRESS}/role`)
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static addRole(role) {
        return fetch(`${global.SERVER_ADDRESS}/role`, {
            method: 'POST',
            body: JSON.stringify(role),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static updateRole(role) {
        return fetch(`${global.SERVER_ADDRESS}/role/${role.slug}`, {
            method: 'PUT',
            body: JSON.stringify(role),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static deleteRole(role) {
        return fetch(`${global.SERVER_ADDRESS}/role/${role.slug}`, {
            method: 'DELETE',
            body: JSON.stringify(role),
            headers: { 'Content-Type': 'application/json' }
        })
            .then(response => response.json())
            .catch(error => this.handleError(error));
    }

    static handleError(error) {
        console.log(error);
    }


}